export enum SuggestedAiPromptCardAs {
  Anchor = 'a',
  Button = 'button',
}
